import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_LOGBOOK_LIST_BY_PROCESS} from "../../graphql/queries/logbook/listByProcess";
import {GET_LOGBOOK_PAGE} from "../../graphql/queries/logbook/getPage";

const state = {
  logs: [],
};

const getters = {
  logbookGetList: state => state.logs
};

const mutations = {
  UPDATE_LOGBOOK_LIST (state, logs) {
    logs.forEach(log => {
      const logEntry = state.logs.find(l => l.id === log.id);
      if(!logEntry || logEntry.parts.length < log.parts.length) {
        state.logs.upsert({id: log.id}, log);
      }
      // if (!state.logs.some(l => l.id === log.id)) {
      //   state.logs.push(log);
      // }
    });
  },
  UPDATE_LOGBOOK_PAGES (state, {id, page, data}) {
    let log = state.logs.find(log => log.id === id);
    if (log) {
      if (!log.parts) {
        log.parts = [];
      }
      log.parts.push(data);
      state.logs.upsert({id: id}, log);
      // vue.set(log.parts, page, data);
    }
  }
};

const actions = {
  async logbookFetchList ({commit}, processId) {
    const {data} = await apolloClient.query({query: GET_LOGBOOK_LIST_BY_PROCESS, variables: {processId: processId}});
    if (data && data.logbookGetByProcess) {
      commit('UPDATE_LOGBOOK_LIST', data.logbookGetByProcess);
    }
  },
  async logbookGetPage ({commit}, payload) {
    const {data} = await apolloClient.query({
      query: GET_LOGBOOK_PAGE, variables: {id: payload.id, page: payload.page}
    });
    if (data && data.logbookGetPage) {
      commit('UPDATE_LOGBOOK_PAGES', {id: payload.id, page: payload.page, data: data.logbookGetPage});
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/logbook.js